<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <template v-if="possibleItems.list.qualities">
          <div class="row border-bottom">
            <div class="col-12 text-start">
              <h5>{{ $t("Menu.list.stones.group.quality.quality") }}</h5>
              <div
                class="row quality-line"
                v-for="(item, index) in possibleItems.list.qualities"
                v-bind:key="index"
                :class="{ on: item.match }"
                @click="changeItem(item.itemnumber)"
              >
                <div class="col-9">{{ item.text }}</div>
                <div class="col-3 text-end">
                  {{ $n(item.price, "currency") }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ul class="default-option-list" v-if="possibleItems.list.variations">
          <li
            v-for="(item, index) in possibleItems.list.variations"
            v-bind:key="index"
            @click="changeItem(item.itemnumber)"
            :class="{ match: item.match }"
            class="pointer"
          >
            <div class="crop-img">
              <img
                :src="
                  getApiHost +
                  '/v2/images/item/f7f5f3/600/600/' +
                  item.itemnumber[0].toUpperCase() +
                  '.jpg'
                "
                :alt="item.itemnumber[0].toUpperCase()"
              />
            </div>
            <p>
              {{ item.text }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "VariationsJewelleryModel",
  props: ["possibleItems"],
  data() {
    return {
      getApiHost: Config.getters.getApiHost,
      appUrl: Config.getters.getAppUrl,
      currentEdit: "",
    };
  },
  methods: {
    changeItem: function (itemnumber, alerts) {
      this.$parent.$parent.changeItem(itemnumber, alerts);
    },
    toggleCurrentEdit: function (id) {
      this.currentEdit = this.currentEdit == id ? "" : id;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  h5 {
    margin-bottom: 1rem;
  }

  .quality-line {
    line-height: 2em;
    padding: 0.5rem 0rem;
    cursor: pointer;
  }

  .quality-line.on {
    background-color: $lightGreyBg;
    font-weight: bold;
  }

  .quality-line:hover {
    background-color: $lightGreyBg;
  }
}
</style>
